import React, { Component } from 'react';
import '../styles/Contact.css'
import ContactMarker from '../images/Footer/marker-small.png'
import MapMarkerBig from '../images/Footer/marker-big.png'
import MapMarker from './MapMarker'
import { injectIntl, defineMessages } from "react-intl"
import { Link } from 'react-router-dom'

const messages = defineMessages({
  tel: {
    id: 'contact.tel',
    defaultMessage: 'Tél'
  },
  openCharonne: {
    id: 'contact.openCharonne',
    defaultMessage: 'Ouvert 7 jours sur 7 de 10h à minuit.'
  },
  openVoltaire: {
    id: 'contact.openVoltaire',
    defaultMessage: 'Ouvert 7 jours sur 7 de 10h à minuit.'
  },
  contactUs: {
    id: 'contact.contactUs',
    defaultMessage: 'Nous contacter'
  }
})

const coordinates = {
  charonne: {
    lat: 48.85592,
    lng: 2.388316
  },
  stMaur: {
    lat: 48.860365,
    lng: 2.383368
  }
}

class Contact extends Component {
  static defaultProps = {
    center: {
      lat: (coordinates.charonne.lat + coordinates.stMaur.lat) / 2,
      lng: (coordinates.charonne.lng + coordinates.stMaur.lng) / 2
    },
    zoom: 14
  };

  constructor(props) {
    super(props)
    this.state = {
      showMap: (window.mapLoaded ? true : false),
      GoogleMapReactComponent: window.GoogleMapReactComponent || null
    }
    this.setMapContainer = element => {
      this.mapContainer = element
    }
  }

  componentDidMount() {
    this.isMountedContact = true
    if (navigator.userAgent === 'ReactSnap') {
        return                                                                                                                                                                                                                                  
    }
    this.loadMapComponent = () => {
      if (this.mapLoadStarted) {
        return
      }
      this.mapLoadStarted = true

      import('google-map-react').then(module => {
        const GoogleMapReactComponent = module.default || module
        window.GoogleMapReactComponent = GoogleMapReactComponent
        window.mapLoaded = true
        if (this.isMountedContact) {
          this.setState({
            showMap: true,
            GoogleMapReactComponent: GoogleMapReactComponent
          })
        }
      })
    }

    this.showMap = () => {
      this.mapTimer = setTimeout(this.loadMapComponent, 600)
    }

    if (window.GoogleMapReactComponent) {
      this.showMap()
    } else if ('IntersectionObserver' in window && this.mapContainer) {
      this.mapObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.mapObserver.disconnect()
          this.showMap()
        }
      }, { rootMargin: '300px 0px' })
      this.mapObserver.observe(this.mapContainer)
    } else if (document.readyState === 'complete') {
      this.showMap()
    } else {
      window.addEventListener('load', this.showMap)
    }
  }

  componentWillUnmount() {
    this.isMountedContact = false
    window.removeEventListener('load', this.showMap)
    if (this.mapObserver) {
      this.mapObserver.disconnect()
    }
    window.clearTimeout(this.mapTimer)
  }

  render() {
    const {intl:{formatMessage}} = this.props
    const GoogleMapReactComponent = this.state.GoogleMapReactComponent
    return (
      <div className="contact">
        <div className="contact-text">
          <div className="contact-text-block contact-text-block--left">
            <h4>
              <div style={{ backgroundImage: `url(${ContactMarker})`}} className="contact-marker">1</div>
              One Hour – Charonne
            </h4>
			<h3>
			  Lost Asylum / Very Bad Night
			</h3>
            <p>24 RUE EMILE LEPEU <br />
            <span className="contact-capitalize">75011 Paris</span>
            </p>
            <p><Link to="/contact/">{formatMessage(messages.contactUs)}
               </Link>
            </p>
            <p>
              {formatMessage(messages.openCharonne)}
            </p>
          </div>
          <div className="contact-text-block">
            <h4>
              <div style={{ backgroundImage: `url(${ContactMarker})`}} className="contact-marker">2</div>
              One Hour – Voltaire
            </h4>
			<h3>
			  L'abattoir / Yakuza / Expédition Maudite
			</h3>
            <p>23 RUE SERVAN <br />
            <span className="contact-capitalize">75011 Paris</span>
            </p>
            <p><Link to="/contact/">{formatMessage(messages.contactUs)}
               </Link>
            </p>
            <p>
              {formatMessage(messages.openVoltaire)}
            </p>
          </div>
        </div>
        <div className="contact-map" ref={this.setMapContainer}>
        {this.state.showMap && GoogleMapReactComponent ? 
          <GoogleMapReactComponent
            bootstrapURLKeys={{ key: "AIzaSyCg0zC4AehnpSR4_oJdQRgEfkqyeUFe80Q" }}
            defaultCenter={this.props.center}
            defaultZoom={this.props.zoom}
          >
          <MapMarker
            icon={MapMarkerBig}
            position={1}
            lat={coordinates.charonne.lat}
            lng={coordinates.charonne.lng}/>
          <MapMarker
            icon={MapMarkerBig}
            position={2}
            lat={coordinates.stMaur.lat}
            lng={coordinates.stMaur.lng}/>
          </GoogleMapReactComponent> : '' }
        </div>
      </div>
    );
  }
}

export default injectIntl(Contact)



// WEBPACK FOOTER //
// ./src/components/Contact.js